function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; var r = _regenerator(), e = r.m(_regeneratorRuntime), t = (Object.getPrototypeOf ? Object.getPrototypeOf(e) : e.__proto__).constructor; function n(r) { var e = "function" == typeof r && r.constructor; return !!e && (e === t || "GeneratorFunction" === (e.displayName || e.name)); } var o = { "throw": 1, "return": 2, "break": 3, "continue": 3 }; function a(r) { var e, t; return function (n) { e || (e = { stop: function stop() { return t(n.a, 2); }, "catch": function _catch() { return n.v; }, abrupt: function abrupt(r, e) { return t(n.a, o[r], e); }, delegateYield: function delegateYield(r, o, a) { return e.resultName = o, t(n.d, _regeneratorValues(r), a); }, finish: function finish(r) { return t(n.f, r); } }, t = function t(r, _t, o) { n.p = e.prev, n.n = e.next; try { return r(_t, o); } finally { e.next = n.n; } }), e.resultName && (e[e.resultName] = n.v, e.resultName = void 0), e.sent = n.v, e.next = n.n; try { return r.call(this, e); } finally { n.p = e.prev, n.n = e.next; } }; } return (_regeneratorRuntime = function _regeneratorRuntime() { return { wrap: function wrap(e, t, n, o) { return r.w(a(e), t, n, o && o.reverse()); }, isGeneratorFunction: n, mark: r.m, awrap: function awrap(r, e) { return new _OverloadYield(r, e); }, AsyncIterator: _regeneratorAsyncIterator, async: function async(r, e, t, o, u) { return (n(e) ? _regeneratorAsyncGen : _regeneratorAsync)(a(r), e, t, o, u); }, keys: _regeneratorKeys, values: _regeneratorValues }; })(); }
function _regeneratorValues(e) { if (null != e) { var t = e["function" == typeof Symbol && Symbol.iterator || "@@iterator"], r = 0; if (t) return t.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) return { next: function next() { return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e }; } }; } throw new TypeError(_typeof(e) + " is not iterable"); }
function _regeneratorKeys(e) { var n = Object(e), r = []; for (var t in n) r.unshift(t); return function e() { for (; r.length;) if ((t = r.pop()) in n) return e.value = t, e.done = !1, e; return e.done = !0, e; }; }
function _regeneratorAsync(n, e, r, t, o) { var a = _regeneratorAsyncGen(n, e, r, t, o); return a.next().then(function (n) { return n.done ? n.value : a.next(); }); }
function _regeneratorAsyncGen(r, e, t, o, n) { return new _regeneratorAsyncIterator(_regenerator().w(r, e, t, o), n || Promise); }
function _regeneratorAsyncIterator(t, e) { function n(r, o, i, f) { try { var c = t[r](o), u = c.value; return u instanceof _OverloadYield ? e.resolve(u.v).then(function (t) { n("next", t, i, f); }, function (t) { n("throw", t, i, f); }) : e.resolve(u).then(function (t) { c.value = t, i(c); }, function (t) { return n("throw", t, i, f); }); } catch (t) { f(t); } } var r; this.next || (_regeneratorDefine2(_regeneratorAsyncIterator.prototype), _regeneratorDefine2(_regeneratorAsyncIterator.prototype, "function" == typeof Symbol && Symbol.asyncIterator || "@asyncIterator", function () { return this; })), _regeneratorDefine2(this, "_invoke", function (t, o, i) { function f() { return new e(function (e, r) { n(t, i, e, r); }); } return r = r ? r.then(f, f) : f(); }, !0); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _OverloadYield(e, d) { this.v = e, this.k = d; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
var _hoisted_1 = {
  "class": "wrap"
};
var _hoisted_2 = {
  key: 0,
  "class": "efc-embed-hero"
};
var _hoisted_3 = {
  "class": "shell"
};
var _hoisted_4 = {
  "class": "panel",
  "aria-label": "Calculator inputs"
};
var _hoisted_5 = {
  "class": "panel-head"
};
var _hoisted_6 = {
  "class": "seg",
  role: "group",
  "aria-label": "Detail level"
};
var _hoisted_7 = ["aria-pressed"];
var _hoisted_8 = ["aria-pressed"];
var _hoisted_9 = {
  "class": "group"
};
var _hoisted_10 = {
  "class": "grid2"
};
var _hoisted_11 = ["open"];
var _hoisted_12 = {
  "class": "group"
};
var _hoisted_13 = {
  "class": "grid2"
};
var _hoisted_14 = {
  "class": "field"
};
var _hoisted_15 = {
  "class": "input"
};
var _hoisted_16 = ["value"];
var _hoisted_17 = ["value"];
var _hoisted_18 = {
  "class": "hint"
};
var _hoisted_19 = {
  "class": "field"
};
var _hoisted_20 = {
  "class": "input"
};
var _hoisted_21 = ["value"];
var _hoisted_22 = {
  "class": "field"
};
var _hoisted_23 = {
  "class": "input"
};
var _hoisted_24 = ["value"];
var _hoisted_25 = {
  "class": "group"
};
var _hoisted_26 = {
  key: 0,
  "class": "grid2 etsy-top-gap"
};
var _hoisted_27 = {
  "class": "field"
};
var _hoisted_28 = {
  "class": "input"
};
var _hoisted_29 = ["value"];
var _hoisted_30 = {
  key: 1,
  "class": "grid2 etsy-top-gap"
};
var _hoisted_31 = {
  "class": "grid2 etsy-top-gap-lg"
};
var _hoisted_32 = {
  "class": "group"
};
var _hoisted_33 = {
  "class": "grid2"
};
var _hoisted_34 = {
  "class": "panel result",
  "aria-label": "Results"
};
var _hoisted_35 = {
  "class": "takehome"
};
var _hoisted_36 = {
  "class": "row"
};
var _hoisted_37 = {
  key: 0
};
var _hoisted_38 = {
  "class": "bar",
  "aria-hidden": "true"
};
var _hoisted_39 = {
  "class": "bd"
};
var _hoisted_40 = {
  key: 0,
  "class": "lbl"
};
var _hoisted_41 = {
  "class": "r"
};
var _hoisted_42 = {
  "class": "metrics"
};
var _hoisted_43 = {
  "class": "m"
};
var _hoisted_44 = {
  "class": "v"
};
var _hoisted_45 = {
  "class": "m"
};
var _hoisted_46 = {
  "class": "v"
};
var _hoisted_47 = {
  "class": "m"
};
var _hoisted_48 = {
  "class": "v"
};
var _hoisted_49 = {
  key: 0,
  "class": "notes"
};
var _hoisted_50 = {
  "class": "ic"
};
var _hoisted_51 = {
  key: 1,
  "class": "empty"
};
var _hoisted_52 = {
  key: 1,
  "class": "efc-embed"
};
var _hoisted_53 = ["value"];
var _hoisted_54 = {
  "class": "efc-embed-actions"
};
var _hoisted_55 = {
  key: 2,
  "class": "efc-powered"
};
var _hoisted_56 = {
  "class": "efc-modal-card"
};
var _hoisted_57 = {
  "class": "efc-modal-head"
};
var _hoisted_58 = {
  "class": "efc-modal-body"
};
var _hoisted_59 = {
  "class": "efc-preview-wrap"
};
var _hoisted_60 = ["src"];
var _hoisted_61 = ["value"];
import { computed, defineComponent, h, nextTick, ref, watch } from 'vue';
import { TOOL_EMBED_PROPS, buildEmbedSnippet, useToolEmbedSupport } from './shared/toolEmbed';
import { useTimedFlag, writeToClipboard } from './shared/toolClipboard';
export default {
  __name: 'etsyFeeCalculator',
  props: TOOL_EMBED_PROPS,
  setup: function setup(__props) {
    var props = __props;
    var CONFIG = {
      offsiteCap: 100,
      countries: {
        US: {
          name: 'United States',
          cur: 'USD',
          sym: '$',
          pct: 3,
          flat: 0.25,
          intlPct: 3,
          reg: 0
        },
        GB: {
          name: 'United Kingdom',
          cur: 'GBP',
          sym: '£',
          pct: 4,
          flat: 0.2,
          intlPct: 4,
          reg: 0.32,
          note: 'UK regulatory operating fee is 0.32% now, rising to 0.48% on 22 Jun 2026.'
        },
        AU: {
          name: 'Australia',
          cur: 'AUD',
          sym: 'A$',
          pct: 3,
          flat: 0.25,
          intlPct: 4,
          reg: 0
        },
        CA: {
          name: 'Canada',
          cur: 'CAD',
          sym: 'C$',
          pct: 3,
          flat: 0.25,
          intlPct: 4,
          reg: 0
        },
        NZ: {
          name: 'New Zealand',
          cur: 'NZD',
          sym: 'NZ$',
          pct: 3,
          flat: 0.3,
          intlPct: 4,
          reg: 0
        },
        IE: {
          name: 'Ireland',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0
        },
        DE: {
          name: 'Germany',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0
        },
        FR: {
          name: 'France',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0,
          note: 'France has a regulatory operating fee — set its current rate in overrides.'
        },
        ES: {
          name: 'Spain',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0,
          note: 'Spain has a regulatory operating fee — set its current rate in overrides.'
        },
        IT: {
          name: 'Italy',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0,
          note: 'Italy has a regulatory operating fee — set its current rate in overrides.'
        },
        NL: {
          name: 'Netherlands',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0
        },
        EU: {
          name: 'Other Eurozone',
          cur: 'EUR',
          sym: '€',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0
        },
        CH: {
          name: 'Switzerland',
          cur: 'CHF',
          sym: 'CHF',
          pct: 4,
          flat: 0.5,
          intlPct: 4,
          reg: 0
        },
        SE: {
          name: 'Sweden',
          cur: 'SEK',
          sym: 'kr',
          pct: 4,
          flat: 3.0,
          intlPct: 4,
          reg: 0
        },
        NO: {
          name: 'Norway',
          cur: 'NOK',
          sym: 'kr',
          pct: 4,
          flat: 2.5,
          intlPct: 4,
          reg: 0
        },
        DK: {
          name: 'Denmark',
          cur: 'DKK',
          sym: 'kr',
          pct: 4,
          flat: 2.5,
          intlPct: 4,
          reg: 0
        },
        HK: {
          name: 'Hong Kong',
          cur: 'HKD',
          sym: 'HK$',
          pct: 4.4,
          flat: 2.0,
          intlPct: 4.4,
          reg: 0
        },
        SG: {
          name: 'Singapore',
          cur: 'SGD',
          sym: 'S$',
          pct: 4.4,
          flat: 0.35,
          intlPct: 4.4,
          reg: 0
        },
        IN: {
          name: 'India',
          cur: 'INR',
          sym: '₹',
          pct: 5,
          flat: 25,
          intlPct: 5,
          reg: 0,
          note: 'India has a regulatory operating fee — set its current rate in overrides.'
        },
        JP: {
          name: 'Japan',
          cur: 'JPY',
          sym: '¥',
          pct: 6,
          flat: 0.3,
          intlPct: 6,
          reg: 0,
          note: 'Japan\'s flat fee is charged in USD ($0.30).'
        },
        MX: {
          name: 'Mexico',
          cur: 'MXN',
          sym: '$',
          pct: 4.5,
          flat: 8.0,
          intlPct: 4.5,
          reg: 0
        },
        ZA: {
          name: 'South Africa',
          cur: 'ZAR',
          sym: 'R',
          pct: 4.5,
          flat: 8.0,
          intlPct: 4.5,
          reg: 0
        },
        XX: {
          name: 'Other / custom',
          cur: 'USD',
          sym: '$',
          pct: 4,
          flat: 0.3,
          intlPct: 4,
          reg: 0,
          note: 'Set your exact processing rate and flat fee in overrides.'
        }
      }
    };
    function clampNum(value) {
      var parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
    }
    function fmt(amount, code, symbol) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency',
          currency: code,
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(amount);
      } catch (error) {
        return "".concat(symbol || '$').concat(amount.toFixed(2));
      }
    }
    function pctLabel(value) {
      return "".concat((value * 100).toFixed(value * 100 % 1 === 0 ? 0 : 1), "%");
    }
    function compute(input) {
      var qty = Math.max(1, Math.floor(input.qty || 1));
      var items = (input.price || 0) * qty;
      var order = items + (input.shipCharged || 0) + (input.giftWrap || 0);
      var fees = {};
      fees.listing = (input.listingFee || 0) * qty;
      fees.transaction = (input.txnRate || 0) * order;
      fees.payment = (input.payPct || 0) * order + (input.payFlat || 0);
      fees.offsite = input.offsiteOn ? Math.min((input.offsiteRate || 0) * order, CONFIG.offsiteCap) : 0;
      fees.offsiteCapped = input.offsiteOn && (input.offsiteRate || 0) * order > CONFIG.offsiteCap;
      fees.regulatory = (input.regRate || 0) * order;
      fees.currency = input.ccOn ? (input.ccRate || 0) * order : 0;
      fees.etsyAds = input.etsyAds || 0;
      var vatBase = fees.listing + fees.transaction + fees.payment + fees.offsite + fees.regulatory + fees.etsyAds;
      fees.vat = input.vatOn ? (input.vatRate || 0) * vatBase : 0;
      var totalFees = fees.listing + fees.transaction + fees.payment + fees.offsite + fees.regulatory + fees.currency + fees.etsyAds + fees.vat;
      var costs = (input.cost || 0) * qty + (input.shipCost || 0) + (input.otherCost || 0);
      var take = order - totalFees - costs;
      return {
        qty: qty,
        items: items,
        order: order,
        fees: fees,
        totalFees: totalFees,
        costs: costs,
        take: take,
        margin: order > 0 ? take / order : 0,
        roi: costs > 0 ? take / costs : null,
        effRate: order > 0 ? totalFees / order : 0
      };
    }
    function solvePrice(base, goalFn) {
      var low = 0;
      var high = 1e7;
      var goal = function goal(price) {
        return goalFn(compute(_objectSpread(_objectSpread({}, base), {}, {
          price: price
        })));
      };
      if (goal(low) > 0) {
        return 0;
      }
      for (var index = 0; index < 60; index += 1) {
        var mid = (low + high) / 2;
        if (goal(mid) < 0) {
          low = mid;
        } else {
          high = mid;
        }
      }
      return (low + high) / 2;
    }
    var HelpBubble = defineComponent({
      name: 'EtsyHelpBubble',
      props: {
        text: {
          type: String,
          required: true
        }
      },
      setup: function setup(componentProps) {
        var open = ref(false);
        return function () {
          return h('span', {
            "class": 'help',
            'data-open': open.value ? 'true' : 'false',
            onMouseenter: function onMouseenter() {
              open.value = true;
            },
            onMouseleave: function onMouseleave() {
              open.value = false;
            }
          }, [h('button', {
            type: 'button',
            'aria-label': 'More information',
            onClick: function onClick(event) {
              event.preventDefault();
              open.value = !open.value;
            },
            onBlur: function onBlur() {
              open.value = false;
            }
          }, '?'), h('span', {
            "class": 'tip',
            role: 'tooltip'
          }, componentProps.text)]);
        };
      }
    });
    var MoneyField = defineComponent({
      name: 'EtsyMoneyField',
      props: {
        id: {
          type: String,
          required: true
        },
        label: {
          type: String,
          required: true
        },
        help: {
          type: String,
          "default": ''
        },
        sym: {
          type: String,
          "default": '$'
        },
        modelValue: {
          type: String,
          "default": ''
        },
        hint: {
          type: String,
          "default": ''
        },
        invalid: {
          type: Boolean,
          "default": false
        },
        errId: {
          type: String,
          "default": ''
        },
        errMsg: {
          type: String,
          "default": ''
        }
      },
      emits: ['update:modelValue'],
      setup: function setup(componentProps, _ref) {
        var emit = _ref.emit;
        return function () {
          return h('div', {
            "class": 'field'
          }, [h('label', {
            "for": componentProps.id
          }, [componentProps.label, componentProps.help ? h(HelpBubble, {
            text: componentProps.help
          }) : null]), h('div', {
            "class": 'input has-cur'
          }, [h('span', {
            "class": 'cur'
          }, componentProps.sym), h('input', {
            id: componentProps.id,
            type: 'number',
            inputmode: 'decimal',
            min: '0',
            step: '0.01',
            placeholder: '0.00',
            value: componentProps.modelValue,
            'aria-invalid': componentProps.invalid ? 'true' : 'false',
            'aria-describedby': componentProps.errId || undefined,
            onInput: function onInput(event) {
              return emit('update:modelValue', event.target.value);
            }
          })]), componentProps.invalid && componentProps.errMsg ? h('p', {
            id: componentProps.errId,
            "class": 'err show'
          }, componentProps.errMsg) : null, componentProps.hint ? h('p', {
            "class": 'hint'
          }, componentProps.hint) : null]);
        };
      }
    });
    var PctField = defineComponent({
      name: 'EtsyPctField',
      props: {
        id: {
          type: String,
          required: true
        },
        label: {
          type: String,
          required: true
        },
        help: {
          type: String,
          "default": ''
        },
        modelValue: {
          type: String,
          "default": ''
        },
        hint: {
          type: String,
          "default": ''
        }
      },
      emits: ['update:modelValue'],
      setup: function setup(componentProps, _ref2) {
        var emit = _ref2.emit;
        return function () {
          return h('div', {
            "class": 'field'
          }, [h('label', {
            "for": componentProps.id
          }, [componentProps.label, componentProps.help ? h(HelpBubble, {
            text: componentProps.help
          }) : null]), h('div', {
            "class": 'input has-suffix'
          }, [h('input', {
            id: componentProps.id,
            type: 'number',
            inputmode: 'decimal',
            min: '0',
            step: '0.1',
            value: componentProps.modelValue,
            onInput: function onInput(event) {
              return emit('update:modelValue', event.target.value);
            }
          }), h('span', {
            "class": 'suffix'
          }, '%')]), componentProps.hint ? h('p', {
            "class": 'hint'
          }, componentProps.hint) : null]);
        };
      }
    });
    var ToggleSwitch = defineComponent({
      name: 'EtsyToggleSwitch',
      props: {
        label: {
          type: String,
          required: true
        },
        sub: {
          type: String,
          "default": ''
        },
        checked: {
          type: Boolean,
          "default": false
        }
      },
      emits: ['update:checked'],
      setup: function setup(componentProps, _ref3) {
        var emit = _ref3.emit;
        return function () {
          return h('button', {
            type: 'button',
            role: 'switch',
            'aria-checked': componentProps.checked,
            "class": 'efc-toggle',
            onClick: function onClick() {
              return emit('update:checked', !componentProps.checked);
            }
          }, [h('span', {
            "class": 'efc-toggle-text'
          }, [componentProps.label, componentProps.sub ? h('span', {
            "class": 'efc-toggle-sub'
          }, componentProps.sub) : null]), h('span', {
            "class": ['efc-switch', {
              on: componentProps.checked
            }],
            'aria-hidden': 'true'
          }, [h('i')])]);
        };
      }
    });
    var usDefaults = CONFIG.countries.US;
    var price = ref('');
    var cost = ref('');
    var shipCharged = ref('');
    var shipCost = ref('');
    var country = ref('US');
    var orderType = ref('domestic');
    var qty = ref('1');
    var giftWrap = ref('');
    var offsiteOn = ref(false);
    var offsiteTier = ref('0.15');
    var ccOn = ref(false);
    var vatOn = ref(false);
    var vatRate = ref('20');
    var etsyAds = ref('');
    var otherCost = ref('');
    var txnRate = ref('6.5');
    var listingFee = ref('0.20');
    var payPct = ref(String(usDefaults.pct));
    var payFlat = ref(usDefaults.flat.toFixed(2));
    var regRate = ref('0');
    var ccRate = ref('2.5');
    var mode = ref('simple');
    var manualText = ref(null);
    var manualRef = ref(null);
    var _useTimedFlag = useTimedFlag(1500),
      embedCopied = _useTimedFlag.flag,
      triggerEmbedCopied = _useTimedFlag.trigger,
      resetEmbedCopied = _useTimedFlag.reset;
    var _useToolEmbedSupport = useToolEmbedSupport({
        props: props
      }),
      rootRef = _useToolEmbedSupport.rootRef,
      previewFrameRef = _useToolEmbedSupport.previewFrameRef,
      showPreview = _useToolEmbedSupport.showPreview,
      isEmbed = _useToolEmbedSupport.isEmbed,
      pageUrl = _useToolEmbedSupport.pageUrl,
      previewSrc = _useToolEmbedSupport.previewSrc,
      showEmbedCard = _useToolEmbedSupport.showEmbedCard,
      closePreview = _useToolEmbedSupport.closePreview;
    var currentCountry = computed(function () {
      return CONFIG.countries[country.value];
    });
    var code = computed(function () {
      return currentCountry.value.cur;
    });
    var symbol = computed(function () {
      return currentCountry.value.sym;
    });
    function changeCountry(codeKey) {
      country.value = codeKey;
      var selected = CONFIG.countries[codeKey];
      var intl = orderType.value === 'intl';
      payPct.value = String(intl ? selected.intlPct : selected.pct);
      payFlat.value = selected.flat.toFixed(2);
      regRate.value = String(selected.reg || 0);
    }
    function changeOrderType(value) {
      orderType.value = value;
      payPct.value = String(value === 'intl' ? currentCountry.value.intlPct : currentCountry.value.pct);
    }
    var inputState = computed(function () {
      return {
        price: clampNum(price.value),
        cost: clampNum(cost.value),
        shipCharged: clampNum(shipCharged.value),
        shipCost: clampNum(shipCost.value),
        qty: Math.max(1, Math.floor(clampNum(qty.value) || 1)),
        giftWrap: clampNum(giftWrap.value),
        etsyAds: clampNum(etsyAds.value),
        otherCost: clampNum(otherCost.value),
        offsiteOn: offsiteOn.value,
        offsiteRate: Number.parseFloat(offsiteTier.value) || 0.15,
        ccOn: ccOn.value,
        ccRate: clampNum(ccRate.value) / 100,
        vatOn: vatOn.value,
        vatRate: clampNum(vatRate.value) / 100,
        txnRate: clampNum(txnRate.value) / 100,
        listingFee: clampNum(listingFee.value),
        payPct: clampNum(payPct.value) / 100,
        payFlat: clampNum(payFlat.value),
        regRate: clampNum(regRate.value) / 100
      };
    });
    var result = computed(function () {
      return compute(inputState.value);
    });
    var hasInput = computed(function () {
      return inputState.value.price > 0 || inputState.value.shipCharged > 0;
    });
    var loss = computed(function () {
      return result.value.take < 0;
    });
    var moneyValue = function moneyValue(value) {
      return fmt(value, code.value, symbol.value);
    };
    var breakeven = computed(function () {
      return solvePrice(inputState.value, function (current) {
        return current.take;
      });
    });
    var priceInvalid = computed(function () {
      return price.value !== '' && Number.parseFloat(price.value) < 0;
    });
    function copyEmbed() {
      return _copyEmbed.apply(this, arguments);
    }
    function _copyEmbed() {
      _copyEmbed = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var didCopy;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return writeToClipboard(embedSnippet.value);
            case 2:
              didCopy = _context.sent;
              if (didCopy) {
                _context.next = 7;
                break;
              }
              resetEmbedCopied();
              manualText.value = embedSnippet.value;
              return _context.abrupt("return");
            case 7:
              triggerEmbedCopied();
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _copyEmbed.apply(this, arguments);
    }
    function reset() {
      price.value = '';
      cost.value = '';
      shipCharged.value = '';
      shipCost.value = '';
      qty.value = '1';
      giftWrap.value = '';
      etsyAds.value = '';
      otherCost.value = '';
      offsiteOn.value = false;
      offsiteTier.value = '0.15';
      ccOn.value = false;
      vatOn.value = false;
      vatRate.value = '20';
      txnRate.value = '6.5';
      listingFee.value = '0.20';
      ccRate.value = '2.5';
      country.value = 'US';
      orderType.value = 'domestic';
      payPct.value = String(usDefaults.pct);
      payFlat.value = usDefaults.flat.toFixed(2);
      regRate.value = '0';
      resetEmbedCopied();
      showPreview.value = false;
    }
    function feeText(value) {
      return value > 0 ? "\u2212".concat(moneyValue(value)) : moneyValue(0);
    }
    var rows = computed(function () {
      var input = inputState.value;
      var fees = result.value.fees;
      var output = [];
      output.push({
        key: 'order',
        label: 'Order total',
        value: moneyValue(result.value.order),
        cls: 'total'
      });
      output.push({
        key: 'items',
        label: "Items (".concat(result.value.qty, ")"),
        value: moneyValue(result.value.items),
        cls: 'sub'
      });
      if (input.shipCharged) {
        output.push({
          key: 'shipc',
          label: 'Shipping charged',
          value: moneyValue(input.shipCharged),
          cls: 'sub'
        });
      }
      if (input.giftWrap) {
        output.push({
          key: 'gift',
          label: 'Gift wrap',
          value: moneyValue(input.giftWrap),
          cls: 'sub'
        });
      }
      output.push({
        key: 'fees',
        label: 'Etsy fees',
        value: feeText(result.value.totalFees),
        cls: 'total'
      });
      output.push({
        key: 'listing',
        label: 'Listing',
        value: feeText(fees.listing),
        cls: 'sub'
      });
      output.push({
        key: 'txn',
        label: "Transaction (".concat(pctLabel(input.txnRate), ")"),
        value: feeText(fees.transaction),
        cls: 'sub'
      });
      output.push({
        key: 'pay',
        label: 'Payment processing',
        value: feeText(fees.payment),
        cls: 'sub'
      });
      if (input.offsiteOn) {
        output.push({
          key: 'offsite',
          label: "Offsite Ads (".concat(pctLabel(input.offsiteRate), ")"),
          value: feeText(fees.offsite),
          cls: 'sub'
        });
      }
      if (fees.regulatory) {
        output.push({
          key: 'reg',
          label: 'Regulatory operating',
          value: feeText(fees.regulatory),
          cls: 'sub'
        });
      }
      if (fees.currency) {
        output.push({
          key: 'currency',
          label: 'Currency conversion',
          value: feeText(fees.currency),
          cls: 'sub'
        });
      }
      if (fees.etsyAds) {
        output.push({
          key: 'ads',
          label: 'Etsy Ads',
          value: feeText(fees.etsyAds),
          cls: 'sub'
        });
      }
      if (fees.vat) {
        output.push({
          key: 'vat',
          label: 'VAT/GST on fees',
          value: feeText(fees.vat),
          cls: 'sub'
        });
      }
      if (result.value.costs > 0) {
        output.push({
          key: 'costs',
          label: 'Your costs',
          value: feeText(result.value.costs),
          cls: 'total'
        });
        if (input.cost) {
          output.push({
            key: 'cost',
            label: "Item cost (".concat(result.value.qty, ")"),
            value: feeText(input.cost * result.value.qty),
            cls: 'sub'
          });
        }
        if (input.shipCost) {
          output.push({
            key: 'shipCost',
            label: 'Shipping label',
            value: feeText(input.shipCost),
            cls: 'sub'
          });
        }
        if (input.otherCost) {
          output.push({
            key: 'other',
            label: 'Other',
            value: feeText(input.otherCost),
            cls: 'sub'
          });
        }
      }
      output.push({
        key: 'profit',
        label: loss.value ? 'Net loss' : 'Net profit',
        value: moneyValue(result.value.take),
        cls: "profit".concat(loss.value ? ' loss' : '')
      });
      return output;
    });
    var notes = computed(function () {
      var list = [];
      var fees = result.value.fees;
      if (loss.value) {
        list.push(['bad', '!', 'This sale loses money. Raise the price, cut costs, or charge more for shipping.']);
      } else if (result.value.margin < 0.1 && hasInput.value) {
        list.push(['warn', '!', 'Thin margin. Under 10% leaves little room for a refund or a postage surprise.']);
      }
      if (fees.offsiteCapped) {
        list.push(['info', 'i', 'Offsite Ads fee hit the $100 per-order cap.']);
      }
      if (ccOn.value) {
        list.push(['info', 'i', 'List in your payout currency to avoid the 2.5% conversion fee.']);
      }
      if (currentCountry.value.note) {
        list.push(['info', 'i', currentCountry.value.note]);
      }
      if (country.value === 'XX') {
        list.push(['warn', '!', 'Set your exact processing rate and flat fee in the overrides above.']);
      }
      return list;
    });
    var widthTake = computed(function () {
      return Math.max(0, result.value.take) / Math.max(result.value.order, 0.0001) * 100;
    });
    var widthFee = computed(function () {
      return result.value.totalFees / Math.max(result.value.order, 0.0001) * 100;
    });
    var widthCost = computed(function () {
      return result.value.costs / Math.max(result.value.order, 0.0001) * 100;
    });
    var embedSnippet = computed(function () {
      return buildEmbedSnippet({
        pageUrl: pageUrl.value,
        iframeTitle: 'Etsy Fee Calculator by SaleHoo',
        initialHeight: 1500
      });
    });
    var copyShortcutLabel = computed(function () {
      return typeof navigator !== 'undefined' && navigator.platform.indexOf('Mac') > -1 ? '⌘C' : 'Ctrl+C';
    });
    watch(manualText, function (value) {
      if (value === null) {
        return;
      }
      nextTick(function () {
        if (manualRef.value) {
          manualRef.value.focus();
          manualRef.value.select();
        }
      });
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "rootRef",
        ref: rootRef,
        "class": _normalizeClass(['efc-root', {
          embed: _unref(isEmbed)
        }])
      }, [_createElementVNode("div", _hoisted_1, [_unref(isEmbed) ? (_openBlock(), _createElementBlock("header", _hoisted_2, _cache[32] || (_cache[32] = [_createElementVNode("h1", null, "Etsy Fee Calculator", -1)]))) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [_createElementVNode("section", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_cache[33] || (_cache[33] = _createElementVNode("h2", null, "Your sale", -1)), _createElementVNode("div", _hoisted_6, [_createElementVNode("button", {
        type: "button",
        "aria-pressed": mode.value === 'simple',
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return mode.value = 'simple';
        })
      }, " Simple ", 8, _hoisted_7), _createElementVNode("button", {
        type: "button",
        "aria-pressed": mode.value === 'advanced',
        onClick: _cache[1] || (_cache[1] = function ($event) {
          return mode.value = 'advanced';
        })
      }, " Advanced ", 8, _hoisted_8)])]), _createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, [_createVNode(_unref(MoneyField), {
        id: "etsy-price",
        label: "Item sale price",
        sym: symbol.value,
        "model-value": price.value,
        help: "The price you list the item for, per item. Etsy's 6.5% transaction fee is charged on this plus shipping.",
        invalid: priceInvalid.value,
        "err-id": "etsy-price-err",
        "err-msg": "Enter a price of 0 or more.",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return price.value = $event;
        })
      }, null, 8, ["sym", "model-value", "invalid"]), _createVNode(_unref(MoneyField), {
        id: "etsy-cost",
        label: "Item cost (what it costs you)",
        sym: symbol.value,
        "model-value": cost.value,
        help: "Materials, supplies or wholesale cost per item. Used to work out profit and margin. Not an Etsy fee.",
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return cost.value = $event;
        })
      }, null, 8, ["sym", "model-value"]), _createVNode(_unref(MoneyField), {
        id: "etsy-ship-charged",
        label: "Shipping you charge the buyer",
        sym: symbol.value,
        "model-value": shipCharged.value,
        help: "What the buyer pays for shipping. Etsy fees apply to this too. Leave at 0 for free shipping.",
        "onUpdate:modelValue": _cache[4] || (_cache[4] = function ($event) {
          return shipCharged.value = $event;
        })
      }, null, 8, ["sym", "model-value"]), _createVNode(_unref(MoneyField), {
        id: "etsy-ship-cost",
        label: "Shipping label cost (what you pay)",
        sym: symbol.value,
        "model-value": shipCost.value,
        help: "What the postage actually costs you. Subtracted from profit. Not an Etsy fee.",
        "onUpdate:modelValue": _cache[5] || (_cache[5] = function ($event) {
          return shipCost.value = $event;
        })
      }, null, 8, ["sym", "model-value"])])]), _createElementVNode("details", {
        "class": "adv",
        open: mode.value === 'advanced'
      }, [_createElementVNode("summary", {
        onClick: _cache[6] || (_cache[6] = _withModifiers(function ($event) {
          return mode.value = mode.value === 'advanced' ? 'simple' : 'advanced';
        }, ["prevent"]))
      }, _cache[34] || (_cache[34] = [_createElementVNode("span", {
        "class": "chev"
      }, "▶", -1), _createTextVNode(" Advanced settings & fee overrides ")])), _createElementVNode("div", _hoisted_12, [_cache[41] || (_cache[41] = _createElementVNode("p", {
        "class": "glabel"
      }, " Order details ", -1)), _createElementVNode("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_cache[35] || (_cache[35] = _createElementVNode("label", {
        "for": "etsy-country"
      }, "Your shop country", -1)), _createElementVNode("div", _hoisted_15, [_createElementVNode("select", {
        id: "etsy-country",
        "class": "bare",
        value: country.value,
        onChange: _cache[7] || (_cache[7] = function ($event) {
          return changeCountry($event.target.value);
        })
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(CONFIG.countries, function (countryConfig, key) {
        return _openBlock(), _createElementBlock("option", {
          key: key,
          value: key
        }, _toDisplayString(countryConfig.name), 9, _hoisted_17);
      }), 128))], 40, _hoisted_16)]), _createElementVNode("p", _hoisted_18, " Processing: " + _toDisplayString(orderType.value === 'intl' ? currentCountry.value.intlPct : currentCountry.value.pct) + "% + " + _toDisplayString(currentCountry.value.sym) + _toDisplayString(currentCountry.value.flat) + " · payout in " + _toDisplayString(currentCountry.value.cur), 1)]), _createElementVNode("div", _hoisted_19, [_cache[37] || (_cache[37] = _createElementVNode("label", {
        "for": "etsy-order-type"
      }, "Buyer location", -1)), _createElementVNode("div", _hoisted_20, [_createElementVNode("select", {
        id: "etsy-order-type",
        "class": "bare",
        value: orderType.value,
        onChange: _cache[8] || (_cache[8] = function ($event) {
          return changeOrderType($event.target.value);
        })
      }, _cache[36] || (_cache[36] = [_createElementVNode("option", {
        value: "domestic"
      }, " Domestic order ", -1), _createElementVNode("option", {
        value: "intl"
      }, " International order ", -1)]), 40, _hoisted_21)]), _cache[38] || (_cache[38] = _createElementVNode("p", {
        "class": "hint"
      }, " Some countries charge a higher processing rate on international orders. ", -1))]), _createElementVNode("div", _hoisted_22, [_cache[39] || (_cache[39] = _createElementVNode("label", {
        "for": "etsy-qty"
      }, "Quantity", -1)), _createElementVNode("div", _hoisted_23, [_createElementVNode("input", {
        id: "etsy-qty",
        type: "number",
        inputmode: "numeric",
        min: "1",
        step: "1",
        value: qty.value,
        onInput: _cache[9] || (_cache[9] = function ($event) {
          return qty.value = $event.target.value;
        })
      }, null, 40, _hoisted_24)]), _cache[40] || (_cache[40] = _createElementVNode("p", {
        "class": "hint"
      }, " Items in this order. Listing fee renews per item sold. ", -1))]), _createVNode(_unref(MoneyField), {
        id: "etsy-gift-wrap",
        label: "Gift wrap charged",
        sym: symbol.value,
        "model-value": giftWrap.value,
        help: "Optional gift-wrap fee you charge the buyer. Etsy fees apply to it.",
        "onUpdate:modelValue": _cache[10] || (_cache[10] = function ($event) {
          return giftWrap.value = $event;
        })
      }, null, 8, ["sym", "model-value"])])]), _createElementVNode("div", _hoisted_25, [_cache[45] || (_cache[45] = _createElementVNode("p", {
        "class": "glabel"
      }, " Etsy options ", -1)), _createVNode(_unref(ToggleSwitch), {
        label: "Offsite Ads sale",
        sub: "Etsy advertised it and the buyer bought within 30 days.",
        checked: offsiteOn.value,
        "onUpdate:checked": _cache[11] || (_cache[11] = function ($event) {
          return offsiteOn.value = $event;
        })
      }, null, 8, ["checked"]), offsiteOn.value ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createElementVNode("div", _hoisted_27, [_cache[43] || (_cache[43] = _createElementVNode("label", {
        "for": "etsy-offsite-tier"
      }, "Offsite Ads rate", -1)), _createElementVNode("div", _hoisted_28, [_createElementVNode("select", {
        id: "etsy-offsite-tier",
        "class": "bare",
        value: offsiteTier.value,
        onChange: _cache[12] || (_cache[12] = function ($event) {
          return offsiteTier.value = $event.target.value;
        })
      }, _cache[42] || (_cache[42] = [_createElementVNode("option", {
        value: "0.15"
      }, " 15% — under $10k in last 365 days ", -1), _createElementVNode("option", {
        value: "0.12"
      }, " 12% — $10k or more in last 365 days ", -1)]), 40, _hoisted_29)]), _cache[44] || (_cache[44] = _createElementVNode("p", {
        "class": "hint"
      }, " Capped at $100 per order. ", -1))])])) : _createCommentVNode("", true), _createVNode(_unref(ToggleSwitch), {
        label: "Currency conversion",
        sub: "You list in a different currency than your payout currency.",
        checked: ccOn.value,
        "onUpdate:checked": _cache[13] || (_cache[13] = function ($event) {
          return ccOn.value = $event;
        })
      }, null, 8, ["checked"]), _createVNode(_unref(ToggleSwitch), {
        label: "VAT / GST on Etsy fees",
        sub: "Etsy adds tax to its fees in some countries. Off if you're not charged it.",
        checked: vatOn.value,
        "onUpdate:checked": _cache[14] || (_cache[14] = function ($event) {
          return vatOn.value = $event;
        })
      }, null, 8, ["checked"]), vatOn.value ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createVNode(_unref(PctField), {
        id: "etsy-vat-rate",
        label: "VAT / GST rate on fees",
        "model-value": vatRate.value,
        hint: "UK is 20%. Applies to Etsy's fees, not to your sale.",
        "onUpdate:modelValue": _cache[15] || (_cache[15] = function ($event) {
          return vatRate.value = $event;
        })
      }, null, 8, ["model-value"])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_31, [_createVNode(_unref(MoneyField), {
        id: "etsy-ads",
        label: "Etsy Ads spent on this sale",
        sym: symbol.value,
        "model-value": etsyAds.value,
        help: "On-site Etsy Ads run on a daily budget, not a per-sale percentage. Enter what you want to attribute to this order, if anything.",
        "onUpdate:modelValue": _cache[16] || (_cache[16] = function ($event) {
          return etsyAds.value = $event;
        })
      }, null, 8, ["sym", "model-value"]), _createVNode(_unref(MoneyField), {
        id: "etsy-other-cost",
        label: "Other costs (packaging, etc.)",
        sym: symbol.value,
        "model-value": otherCost.value,
        "onUpdate:modelValue": _cache[17] || (_cache[17] = function ($event) {
          return otherCost.value = $event;
        })
      }, null, 8, ["sym", "model-value"])])]), _createElementVNode("div", _hoisted_32, [_cache[46] || (_cache[46] = _createElementVNode("p", {
        "class": "glabel"
      }, [_createTextVNode(" Fee overrides "), _createElementVNode("span", {
        "class": "glabel-sub"
      }, "— change only if you know your rates differ")], -1)), _createElementVNode("div", _hoisted_33, [_createVNode(_unref(PctField), {
        id: "etsy-txn-rate",
        label: "Transaction fee",
        "model-value": txnRate.value,
        "onUpdate:modelValue": _cache[18] || (_cache[18] = function ($event) {
          return txnRate.value = $event;
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(MoneyField), {
        id: "etsy-listing-fee",
        label: "Listing fee (per item)",
        sym: symbol.value,
        "model-value": listingFee.value,
        "onUpdate:modelValue": _cache[19] || (_cache[19] = function ($event) {
          return listingFee.value = $event;
        })
      }, null, 8, ["sym", "model-value"]), _createVNode(_unref(PctField), {
        id: "etsy-pay-pct",
        label: "Payment processing rate",
        "model-value": payPct.value,
        "onUpdate:modelValue": _cache[20] || (_cache[20] = function ($event) {
          return payPct.value = $event;
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(MoneyField), {
        id: "etsy-pay-flat",
        label: "Payment processing flat fee",
        sym: symbol.value,
        "model-value": payFlat.value,
        "onUpdate:modelValue": _cache[21] || (_cache[21] = function ($event) {
          return payFlat.value = $event;
        })
      }, null, 8, ["sym", "model-value"]), _createVNode(_unref(PctField), {
        id: "etsy-reg-rate",
        label: "Regulatory operating fee",
        "model-value": regRate.value,
        help: "A small per-order fee Etsy charges in some countries (UK, France, Italy, Spain, Turkey, India and others). Set your country's rate if it applies.",
        "onUpdate:modelValue": _cache[22] || (_cache[22] = function ($event) {
          return regRate.value = $event;
        })
      }, null, 8, ["model-value"]), _createVNode(_unref(PctField), {
        id: "etsy-cc-rate",
        label: "Currency conversion rate",
        "model-value": ccRate.value,
        "onUpdate:modelValue": _cache[23] || (_cache[23] = function ($event) {
          return ccRate.value = $event;
        })
      }, null, 8, ["model-value"])])])], 8, _hoisted_11), _createElementVNode("div", {
        "class": "btn-row"
      }, [_createElementVNode("button", {
        type: "button",
        "class": "btn btn-subtle",
        onClick: reset
      }, _cache[47] || (_cache[47] = [_createElementVNode("svg", {
        "class": "ico",
        viewBox: "0 0 24 24",
        fill: "none",
        stroke: "currentColor",
        "stroke-width": "2",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "aria-hidden": "true"
      }, [_createElementVNode("polyline", {
        points: "1 4 1 10 7 10"
      }), _createElementVNode("path", {
        d: "M3.51 15a9 9 0 1 0 2.13-9.36L1 10"
      })], -1), _createTextVNode(" Reset data ")]))])]), _createElementVNode("aside", null, [_createElementVNode("section", _hoisted_34, [_createElementVNode("div", _hoisted_35, [_cache[50] || (_cache[50] = _createElementVNode("p", {
        "class": "cap"
      }, " You take home ", -1)), _createElementVNode("div", {
        "class": _normalizeClass(['big', {
          loss: loss.value
        }]),
        "aria-live": "polite"
      }, _toDisplayString(hasInput.value ? moneyValue(result.value.take) : '—'), 3), _createElementVNode("div", _hoisted_36, [_createElementVNode("span", {
        "class": _normalizeClass(['pill', loss.value ? 'loss' : 'green'])
      }, _toDisplayString((result.value.margin * 100).toFixed(1)) + "% margin", 3), _createElementVNode("span", null, [_cache[48] || (_cache[48] = _createTextVNode("on a ")), _createElementVNode("b", null, _toDisplayString(symbol.value) + _toDisplayString(result.value.order.toFixed(2)), 1), _cache[49] || (_cache[49] = _createTextVNode(" order"))])])]), hasInput.value ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createElementVNode("span", {
        "class": "s-take",
        style: _normalizeStyle({
          width: "".concat(widthTake.value, "%")
        })
      }, null, 4), _createElementVNode("span", {
        "class": "s-fee",
        style: _normalizeStyle({
          width: "".concat(widthFee.value, "%")
        })
      }, null, 4), _createElementVNode("span", {
        "class": "s-cost",
        style: _normalizeStyle({
          width: "".concat(widthCost.value, "%")
        })
      }, null, 4)]), _cache[54] || (_cache[54] = _createElementVNode("div", {
        "class": "legend",
        "aria-hidden": "true"
      }, [_createElementVNode("span", null, [_createElementVNode("i", {
        style: {
          "background": "var(--green)"
        }
      }), _createTextVNode("Take-home")]), _createElementVNode("span", null, [_createElementVNode("i", {
        style: {
          "background": "var(--blue)"
        }
      }), _createTextVNode("Etsy fees")]), _createElementVNode("span", null, [_createElementVNode("i", {
        style: {
          "background": "#b9c0cf"
        }
      }), _createTextVNode("Your costs")])], -1)), _createElementVNode("table", _hoisted_39, [_createElementVNode("tbody", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rows.value, function (row) {
        return _openBlock(), _createElementBlock("tr", {
          key: row.key,
          "class": _normalizeClass(row.cls)
        }, [_createElementVNode("td", null, [row.cls.indexOf('sub') > -1 ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(row.label), 1)) : (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_createTextVNode(_toDisplayString(row.label), 1)], 64))]), _createElementVNode("td", _hoisted_41, _toDisplayString(row.value), 1)], 2);
      }), 128))])]), _createElementVNode("div", _hoisted_42, [_createElementVNode("div", _hoisted_43, [_createElementVNode("div", _hoisted_44, _toDisplayString((result.value.effRate * 100).toFixed(1)) + "% ", 1), _cache[51] || (_cache[51] = _createElementVNode("div", {
        "class": "k"
      }, " Effective fee rate ", -1))]), _createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, _toDisplayString(moneyValue(breakeven.value)), 1), _cache[52] || (_cache[52] = _createElementVNode("div", {
        "class": "k"
      }, " Breakeven price ", -1))]), _createElementVNode("div", _hoisted_47, [_createElementVNode("div", _hoisted_48, _toDisplayString(result.value.roi === null ? '—' : "".concat((result.value.roi * 100).toFixed(0), "%")), 1), _cache[53] || (_cache[53] = _createElementVNode("div", {
        "class": "k"
      }, " Return on cost ", -1))])]), notes.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notes.value, function (note, index) {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          "class": _normalizeClass(['note', note[0]])
        }, [_createElementVNode("span", _hoisted_50, _toDisplayString(note[1]), 1), _createElementVNode("span", null, _toDisplayString(note[2]), 1)], 2);
      }), 128))])) : _createCommentVNode("", true)])) : (_openBlock(), _createElementBlock("div", _hoisted_51, _cache[55] || (_cache[55] = [_createElementVNode("div", {
        "class": "mk"
      }, " 🧮 ", -1), _createElementVNode("h3", null, "Enter a sale price to start", -1), _createElementVNode("p", null, "Your fees, profit and margin appear here as you type.", -1)])))])])]), _unref(showEmbedCard) ? (_openBlock(), _createElementBlock("section", _hoisted_52, [_cache[56] || (_cache[56] = _createElementVNode("h2", {
        "class": "efc-embed-h"
      }, " Add calculator to your site ", -1)), _cache[57] || (_cache[57] = _createElementVNode("p", {
        "class": "efc-embed-sub"
      }, " Copy the snippet and paste it into any page or blog post. It resizes to fit and works on mobile. ", -1)), _createElementVNode("textarea", {
        "class": "efc-embed-code",
        readonly: "",
        rows: "4",
        value: embedSnippet.value,
        "aria-label": "Embed code",
        onClick: _cache[24] || (_cache[24] = function ($event) {
          return $event.target.select();
        })
      }, null, 8, _hoisted_53), _createElementVNode("div", _hoisted_54, [_createElementVNode("button", {
        type: "button",
        "class": "btn btn-primary",
        onClick: copyEmbed
      }, _toDisplayString(_unref(embedCopied) ? 'Copied' : 'Copy embed code'), 1), _createElementVNode("button", {
        type: "button",
        "class": "btn btn-ghost",
        onClick: _cache[25] || (_cache[25] = function ($event) {
          return showPreview.value = !_unref(showPreview);
        })
      }, _toDisplayString(_unref(showPreview) ? 'Hide preview' : 'Preview embed'), 1)])])) : _createCommentVNode("", true), _unref(isEmbed) ? (_openBlock(), _createElementBlock("p", _hoisted_55, _cache[58] || (_cache[58] = [_createTextVNode(" Powered by "), _createElementVNode("a", {
        href: "https://www.salehoo.com",
        target: "_blank",
        rel: "noopener"
      }, "SaleHoo", -1)]))) : _createCommentVNode("", true)]), _unref(showPreview) ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        "class": "efc-modal",
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "etsy-preview-title",
        onClick: _cache[27] || (_cache[27] = _withModifiers(function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        }, ["self"]))
      }, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_cache[59] || (_cache[59] = _createElementVNode("h3", {
        id: "etsy-preview-title"
      }, " Embed preview ", -1)), _createElementVNode("button", {
        type: "button",
        "class": "efc-modal-close",
        "aria-label": "Close preview",
        onClick: _cache[26] || (_cache[26] = function () {
          return _unref(closePreview) && _unref(closePreview).apply(void 0, arguments);
        })
      }, " ✕ ")]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createElementVNode("iframe", {
        ref_key: "previewFrameRef",
        ref: previewFrameRef,
        "class": "efc-preview-frame",
        src: _unref(previewSrc),
        title: "Embed preview",
        loading: "lazy"
      }, null, 8, _hoisted_60)])])])])) : _createCommentVNode("", true), manualText.value !== null ? (_openBlock(), _createElementBlock("div", {
        key: 1,
        "class": "copy-modal",
        role: "dialog",
        "aria-label": "Copy text",
        onClick: _cache[31] || (_cache[31] = function ($event) {
          return manualText.value = null;
        })
      }, [_createElementVNode("div", {
        "class": "copy-card",
        onClick: _cache[30] || (_cache[30] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("p", null, "Press " + _toDisplayString(copyShortcutLabel.value) + " to copy:", 1), _createElementVNode("textarea", {
        ref_key: "manualRef",
        ref: manualRef,
        readonly: "",
        value: manualText.value,
        onFocus: _cache[28] || (_cache[28] = function ($event) {
          return $event.target.select();
        })
      }, null, 40, _hoisted_61), _createElementVNode("button", {
        type: "button",
        "class": "btn btn-primary",
        onClick: _cache[29] || (_cache[29] = function ($event) {
          return manualText.value = null;
        })
      }, " Done ")])])) : _createCommentVNode("", true)], 2);
    };
  }
};